/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

import { Typography, withStyles, Grid, Button, Container } from '@material-ui/core';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import Chip from '@material-ui/core/Chip';
import { isObject } from 'lodash';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import { applicationActions } from 'aurora-utils/constants';
import { keyEmptyCheck } from 'aurora-utils/utils';
import ADGMImage from '../ADGMImage';
import styles from './styles';

const ADGMSuccessScreen2 = props => {
  const {
    classes,
    history,
    title,
    applicationNumber,
    label,
    details,
    applicationAction,
    propertyType,
    propertyAddress,
    showDownloadBtn,
    downloadContractHandler,
    downloadTitleDeedHandler,
    downloadPaymentHandler,
    application,
  } = props;

  const goToPropertyHandler = () => {
    history.push('/');
  };

  const getIcon = action => {
    switch (action) {
      case applicationActions.success:
        return 'successIcon.svg';
      case applicationActions.terminate:
        return 'errorIcon.svg';
      case applicationActions.reject:
        return 'discardIcon.svg';
      default:
        return null;
    }
  };

  const getTitleColorClass = action => {
    switch (action) {
      case applicationActions.success:
        return classes.textHolderSuccess;
      case applicationActions.terminate:
        return classes.textHolderTerminate;
      case applicationActions.reject:
        return classes.textHolderReject;
      default:
        return '';
    }
  };
  let loggedInUser = null;
  if (localStorage.getItem('selectedAccount')) {
    const adddata = localStorage?.selectedAccount;
    loggedInUser = JSON.parse(adddata);
  }
  const userTypeIsSignatory = loggedInUser?.subUserType === 'SIGNATORY';
  const titleDeedShow = () => {
    if (
      (application.owners?.filter(owner => owner.companyId === loggedInUser?.companyId).length > 0 &&
        userTypeIsSignatory) ||
      !userTypeIsSignatory
    ) {
      return true;
    }
    return false;
  };
  // const isFeedbackGiven = isFeedbackProvided(
  //   application?.applicationDetails?.initiatorUserId,
  //   application?.applicationDetails?.happinessMeter,
  //   application?.applicationDetails?.applicationStatus,
  // );
  return (
    <Container className={classes.container}>
      {/* {!isFeedbackGiven && (
        <HappinessMeter
          applicationNumber={application?.applicationDetails?.applicationNumber}
          applicationId={application?.applicationDetails?.applicationId}
          applicationType={application?.applicationDetails?.applicationType}
        />
      )} */}
      <Grid container spacing={3} justify='center'>
        <Grid item xs={12}>
          <div className={classes.contentArea}>
            <div className={classes.bannerArea}>
              <div>
                <ADGMImage name={getIcon(applicationAction)} alt='success img' />
              </div>
              <div className={classes.textHolder}>
                <Typography
                  variant='h6'
                  component='h1'
                  className={`${classes.Title} ${getTitleColorClass(applicationAction)}`}
                >
                  {keyEmptyCheck(title)}
                </Typography>
                <div className={classes.downloadActionsWrapper}>
                  {showDownloadBtn && (
                    <Button className={classes.textDownload} onClick={downloadContractHandler}>
                      <ADGMImage name='Download-Icon.svg' alt='Icon' width='16px' height='16px' />
                      {keyEmptyCheck('download_mortgage_certificate')}
                    </Button>
                  )}
                  {downloadPaymentHandler && (
                    <Button className={classes.textDownload} onClick={downloadPaymentHandler}>
                      <ADGMImage name='Download-Icon.svg' alt='Icon' width='16px' height='16px' />
                      {keyEmptyCheck('download_payment_receipt')}
                    </Button>
                  )}
                  {showDownloadBtn && titleDeedShow() && (
                    <Button className={classes.textDownload} onClick={downloadTitleDeedHandler}>
                      <ADGMImage name='Download-Icon.svg' alt='Icon' width='16px' height='16px' />
                      {keyEmptyCheck('download_mortgaged_title_deed')}
                    </Button>
                  )}
                </div>
              </div>
            </div>
            {/* Test */}
            <div className={classNames(classes.detailItem, classes.itemRight)}>
              <Typography align='right'>
                <FormattedMessage {...messages.Application_ID} />
                {': '}
                <span className={classes.strongText}>{applicationNumber}</span>
              </Typography>
            </div>

            <div className={classes.detailItemHorizontal}>
              <div className={classes.item}>
                <ADGMItemDetails label='Properties' value={propertyAddress.join(', ')} />
              </div>
              <Chip
                label={keyEmptyCheck(propertyType)}
                className={classNames(classes.darkgreen, classes.initibadges)}
              />
            </div>
            <div className={classes.detailItem}>
              <ADGMItemDetails label={label} />
              <Grid container>
                {isObject(details) &&
                  Object.keys(details)?.map(key => (
                    <Grid item xs={12} sm={6} md={4} className={classes.marginTop}>
                      <ADGMItemDetails key={key} label={key} value={details[key]} />
                    </Grid>
                  ))}
              </Grid>
            </div>
            {/* End Test */}
            <div className={classes.footerBtnHolder}>
              <Button variant='contained' className={classes.gotoproBtn} onClick={goToPropertyHandler}>
                <FormattedMessage {...messages.go_to_properties} />
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

ADGMSuccessScreen2.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  application: PropTypes.object.isRequired,
  property: PropTypes.object.isRequired,
  details: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  applicationNumber: PropTypes.string.isRequired,
  applicationAction: PropTypes.string.isRequired,
  propertyType: PropTypes.string.isRequired,
  propertyAddress: PropTypes.string.isRequired,
  showDownloadBtn: PropTypes.bool,
  downloadContractHandler: PropTypes.func,
  downloadPaymentHandler: PropTypes.func,
  downloadTitleDeedHandler: PropTypes.func,
};

ADGMSuccessScreen2.defaultProps = {
  showDownloadBtn: false,
  downloadContractHandler: null,
  downloadTitleDeedHandler: null,
  downloadPaymentHandler: null,
};

export default withStyles(styles)(ADGMSuccessScreen2);
